import type { ComponentPropI } from "@Common/types/resources";
import { FormComponent } from "@Src/resources/forms/FormComponent";
import { Create } from "react-admin";

// Public form creation page
export const FormsPublicCreate = (props: ComponentPropI) => {
	return (
		<Create
			disableAuthentication={props.isPublic}
			redirect="/bravo"
			mutationMode="pessimistic"
		>
			<FormComponent type="create_public" />
		</Create>
	);
};
